/**
 * 데모 모드에서 부모 창과 통신하는 메시지 상수들
 */

/**
 * 데모 애플리케이션과 부모 창 간의 통신 메시지 상수들
 */
export const IFRAME_MESSAGES = {
  /**
   * 데모 로드 완료 알림
   *
   * @example
   * window.parent.postMessage(IFRAME_MESSAGES.IFRAME_LOADED, "*");
   */
  IFRAME_LOADED: "Demo Loaded",

  /**
   * 메시지 요청
   *
   * @example
   * window.parent.postMessage(IFRAME_MESSAGES.REQUEST_MESSAGE, "*");
   */
  REQUEST_MESSAGE: "Request Message",
} as const;

/**
 * 데모 메시지 타입
 */
export type IframeMessageType =
  (typeof IFRAME_MESSAGES)[keyof typeof IFRAME_MESSAGES];
